var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListViewBudget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21243_38649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70426 1.5H2.63847C1.88998 1.5 1.2832 2.10677 1.2832 2.85526V6.92105C1.2832 7.66954 1.88998 8.27631 2.63847 8.27631H6.70426C7.45275 8.27631 8.05952 7.66954 8.05952 6.92105V2.85526C8.05952 2.10677 7.45275 1.5 6.70426 1.5Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9279 1.5H11.8621C11.1136 1.5 10.5068 2.10677 10.5068 2.85526V6.92105C10.5068 7.66954 11.1136 8.27631 11.8621 8.27631H15.9279C16.6764 8.27631 17.2832 7.66954 17.2832 6.92105V2.85526C17.2832 2.10677 16.6764 1.5 15.9279 1.5Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70426 10.7236H2.63847C1.88998 10.7236 1.2832 11.3304 1.2832 12.0789V16.1447C1.2832 16.8932 1.88998 17.4999 2.63847 17.4999H6.70426C7.45275 17.4999 8.05952 16.8932 8.05952 16.1447V12.0789C8.05952 11.3304 7.45275 10.7236 6.70426 10.7236Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9279 10.7231H11.8621C11.1136 10.7231 10.5068 11.3299 10.5068 12.0784V16.1442C10.5068 16.8927 11.1136 17.4995 11.8621 17.4995H15.9279C16.6764 17.4995 17.2832 16.8927 17.2832 16.1442V12.0784C17.2832 11.3299 16.6764 10.7231 15.9279 10.7231Z",
    fill: "#CED4DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21243_38649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16,
    fill: "white",
    transform: "translate(1.2832 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewBudget);
export default __webpack_public_path__ + "static/media/listViewBudget.62b69b1352053e6142f37f7cff416181.svg";
export { ForwardRef as ReactComponent };